export const VDR_FOLDER_CATALOG = {
    'Information Technology': [
        {
            name: 'Application Architecture',
            description: 'Documentation describing the application landscape, major platforms, architecture and dependencies.',
            recommended: true,
            examples: ['Application landscape diagram', 'System dependency map', 'Platform architecture overview'],
        },
        {
            name: 'Infrastructure & Cloud',
            description: 'Details of on-premise and cloud infrastructure, hosting environments and cloud strategy.',
            recommended: true,
            examples: ['Cloud architecture diagrams', 'Infrastructure inventory', 'Cloud spend reports'],
        },
        {
            name: 'Data & Analytics',
            description: 'Data architecture, governance, analytics platforms and reporting capabilities.',
            recommended: true,
            examples: ['Data architecture diagram', 'Data governance policy', 'Analytics platform inventory'],
        },
        {
            name: 'Technology Roadmap',
            description: 'Forward-looking technology strategy, planned investments and roadmap items.',
            recommended: true,
            examples: ['Technology roadmap', 'Planned investment schedule', 'Strategic initiative brief'],
        },
        {
            name: 'Vendor & Contracts',
            description: 'Key technology vendor relationships, SLAs and contract terms.',
            recommended: true,
            examples: ['Vendor contract register', 'SLA summary', 'Software licence inventory'],
        },
        {
            name: 'IT Operations',
            description: 'IT service management, support processes and operational procedures.',
            recommended: true,
            examples: ['IT service catalogue', 'Support operating model', 'Incident and request metrics'],
        },
        {
            name: 'Enterprise Architecture',
            description: 'Enterprise architecture artefacts, principles and governance documentation.',
            examples: ['Enterprise architecture principles', 'Reference architecture', 'Architecture governance policy'],
        },
        {
            name: 'Digital & Product',
            description: 'Digital product documentation, UX research and product management artefacts.',
            examples: ['Product roadmap', 'UX research summary', 'Digital product inventory'],
        },
        {
            name: 'IT Governance',
            description: 'IT governance frameworks, policies and compliance documentation.',
            examples: ['IT governance policy', 'IT risk register', 'IT steering committee charter'],
        },
        {
            name: 'Software Engineering',
            description: 'Development practices, engineering standards and delivery capability.',
            examples: ['Engineering standards', 'SDLC overview', 'Delivery metrics report'],
        },
    ],
    Cybersecurity: [
        {
            name: 'Security Policies & Standards',
            description: 'Information security policy, standards and governance documentation.',
            recommended: true,
            examples: ['Information security policy', 'Acceptable use standard', 'Security governance framework'],
        },
        {
            name: 'Vulnerability Management',
            description: 'Vulnerability assessment results, patch management processes and remediation records.',
            recommended: true,
            examples: ['Vulnerability assessment report', 'Patch management procedure', 'Remediation tracker'],
        },
        {
            name: 'Incident Response',
            description: 'Incident response plans, historical incidents and forensic capability.',
            recommended: true,
            examples: ['Incident response plan', 'Recent incident record', 'Tabletop exercise report'],
        },
        {
            name: 'Compliance & Certifications',
            description: 'Security certifications, audit reports and regulatory compliance evidence.',
            recommended: true,
            examples: ['SOC 2 report', 'ISO 27001 certificate', 'Security audit report'],
        },
        {
            name: 'Third-Party Security',
            description: 'Supplier security assessments and third-party risk management.',
            examples: ['Supplier security assessment', 'Third-party risk register', 'Vendor security questionnaire'],
        },
        {
            name: 'Security Architecture',
            description: 'Security architecture documentation and network security controls.',
            examples: ['Security architecture diagram', 'Network security standard', 'Control design overview'],
        },
    ],
};

const CATALOG_ALIASES = {
    'Cyber Outside In': 'Cybersecurity',
};

export function catalogForWorkstream(name) {
    if (VDR_FOLDER_CATALOG[name]) return VDR_FOLDER_CATALOG[name];
    const alias = CATALOG_ALIASES[name];
    return alias ? VDR_FOLDER_CATALOG[alias] || [] : [];
}
